<!-- <div class="content-wrapper container-xxl p-0"> -->
<div class="content-wrapper">
    <div class="content-body">
        <!-- content-header component -->
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <section id="sample-page">
            <div class="row">
                <div id="stepper1" class="bs-stepper horizontal-wizard-example"></div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-body pb-1">
                            <form #cadastroForm="ngForm">
                                <div class="card-body pb-1">
                                    <h4>Informações Básicas do Plano:</h4>

                                    <div class="row">
                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Plano *</label>
                                                <input [(ngModel)]="planoInterface.plano" #Ref1="ngModel"
                                                    class="form-ngModel" required type="text" name="plano"
                                                    class="form-control"
                                                    [class.error]="!Ref1.valid && cadastroForm.submitted"
                                                    placeholder="Plano" />
                                                <span *ngIf="cadastroForm.submitted && Ref1.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref1.errors.required">
                                                        Campo Obrigatório!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label for="basicSelect">Status *</label>
                                                <select [(ngModel)]="planoInterface.id_status" #Ref2="ngModel"
                                                    [class.error]="!Ref2.valid && cadastroForm.submitted"
                                                    name="id_status" class="form-control" id="basicSelect" required>
                                                    <option value="1">Ativo</option>
                                                    <option value="2">Inativo</option>
                                                </select>
                                                <span *ngIf="cadastroForm.submitted && Ref2.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref2.errors.required">
                                                        Selecione uma opção!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Pacote *</label>
                                                <input [(ngModel)]="planoInterface.pacote" #Ref3="ngModel"
                                                    class="form-ngModel" required  type="text"  (input)="sanitizeInput($event)" name="pacote"
                                                    class="form-control"
                                                    [class.error]="!Ref3.valid && cadastroForm.submitted"
                                                    placeholder="Pacote" />
                                                <span *ngIf="cadastroForm.submitted && Ref3.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref3.errors.required">
                                                        Campo Obrigatório!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label for="basicSelect">Broker *</label>
                                                <select [(ngModel)]="planoInterface.id_broker" #Ref4="ngModel"
                                                    [class.error]="!Ref4.valid && cadastroForm.submitted"
                                                    name="id_broker" class="form-control" id="basicSelect"
                                                    required>
                                                    <option [value]="0">
                                                        Selecione um Broker
                                                    </option>
                                                    <option [value]="item.id_broker" *ngFor="let item of brokers">
                                                        {{item.broker}}
                                                    </option>
                                                </select>
                                                <span *ngIf="cadastroForm.submitted && Ref4.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref4.errors.required">
                                                        Selecione uma opção!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label for="basicSelect">Tipo Item *</label>
                                                <select [(ngModel)]="planoInterface.id_tipo_item" #Ref12="ngModel"
                                                    [class.error]="!Ref12.valid && cadastroForm.submitted"
                                                    name="id_tipo_item" class="form-control" id="basicSelect" required>
                                                    <option [value]="0">
                                                        Selecione um Tipo de Item
                                                    </option>
                                                    <option [value]="item.id_tipo_item" *ngFor="let item of tipoItems">
                                                        {{item.tipo}}
                                                    </option>
                                                </select>
                                                <span *ngIf="cadastroForm.submitted && Ref12.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref12.errors.required">
                                                        Selecione uma opção!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Tipo Fluxo *</label>
                                                <select [(ngModel)]="planoInterface.id_tipo_fluxo" #Ref5="ngModel"
                                                    [class.error]="!Ref5.valid && cadastroForm.submitted"
                                                    name="id_tipo_fluxo" class="form-control" id="basicSelect" required>
                                                    <option [value]="0">
                                                        Selecione um Fluxo
                                                    </option>
                                                    <option [value]="1">
                                                        Entrada
                                                    </option>
                                                    <option [value]="2">
                                                        Saída
                                                    </option>
                                                </select>
                                                <span *ngIf="cadastroForm.submitted && Ref5.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref5.errors.required">
                                                        Selecione uma opção!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        
                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label for="basicSelect">Operadora *</label>
                                                <select [(ngModel)]="planoInterface.id_operadora" #Ref12="ngModel"
                                                    [class.error]="!Ref12.valid && cadastroForm.submitted"
                                                    name="id_operadora" class="form-control" id="basicSelect" required>
                                                    <option [value]="0">
                                                        Selecione uma operadora
                                                    </option>
                                                    <option [value]="item.id_operadora" *ngFor="let item of operadoras">
                                                        {{item.operadora}}
                                                    </option>
                                                </select>
                                                <span *ngIf="cadastroForm.submitted && Ref12.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref12.errors.required">
                                                        Selecione uma opção!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <hr class="invoice-spacing mb-5" />

                                    <h4>Valores do Plano:</h4>

                                    <div class="row">

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Valor Mensal *</label>
                                                <input [(ngModel)]="planoInterface.valor_mensal" #Ref6="ngModel"
                                                    class="form-ngModel" required prefix="R$ " type="text"
                                                    mask="separator.2" name="valor_mensal" class="form-control"
                                                    [class.error]="!Ref6.valid && cadastroForm.submitted"
                                                    placeholder="Valor Mensal" />
                                                <span *ngIf="cadastroForm.submitted && Ref6.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref6.errors.required">
                                                        Campo Obrigatório!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Valor Ativação *</label>
                                                <input [(ngModel)]="planoInterface.valor_ativacao" #Ref7="ngModel"
                                                    class="form-ngModel" required prefix="R$ " type="text"
                                                    mask="separator.2" name="valor_ativacao" class="form-control"
                                                    [class.error]="!Ref7.valid && cadastroForm.submitted"
                                                    placeholder="Valor Ativação" />
                                                <span *ngIf="cadastroForm.submitted && Ref7.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref7.errors.required">
                                                        Campo Obrigatório!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Valor Cancelamento *</label>
                                                <input [(ngModel)]="planoInterface.valor_cancelar" #Ref8="ngModel"
                                                    class="form-ngModel" required prefix="R$ " type="text"
                                                    mask="separator.2" name="valor_cancelar" class="form-control"
                                                    [class.error]="!Ref8.valid && cadastroForm.submitted"
                                                    placeholder="Valor Cancelamento" />
                                                <span *ngIf="cadastroForm.submitted && Ref8.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref8.errors.required">
                                                        Campo Obrigatório!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Valor Reativação *</label>
                                                <input [(ngModel)]="planoInterface.valor_reativacao" #Ref9="ngModel"
                                                    class="form-ngModel" required prefix="R$ " type="text"
                                                    mask="separator.2" name="valor_reativacao" class="form-control"
                                                    [class.error]="!Ref9.valid && cadastroForm.submitted"
                                                    placeholder="Valor Reativação" />
                                                <span *ngIf="cadastroForm.submitted && Ref9.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref9.errors.required">
                                                        Campo Obrigatório!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Valor de Negociação Máximo *</label>
                                                <input [(ngModel)]="planoInterface.valor_max" #Ref10="ngModel"
                                                    class="form-ngModel" required prefix="R$ " type="text"
                                                    mask="separator.2" name="valor_max" class="form-control"
                                                    [class.error]="!Ref10.valid && cadastroForm.submitted"
                                                    placeholder="Valor de Negociação Máximo" />
                                                <span *ngIf="cadastroForm.submitted && Ref10.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref10.errors.required">
                                                        Campo Obrigatório!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-12">
                                            <div class="form-group mb-2">
                                                <label>Valor de Negociação Mínimo *</label>
                                                <input [(ngModel)]="planoInterface.valor_min" #Ref11="ngModel"
                                                    class="form-ngModel" required prefix="R$ " type="text"
                                                    mask="separator.2" name="valor_min" class="form-control"
                                                    [class.error]="!Ref11.valid && cadastroForm.submitted"
                                                    placeholder="Valor de Negociação Mínimo" />
                                                <span *ngIf="cadastroForm.submitted && Ref11.invalid"
                                                    class="invalid-form">
                                                    <small class="form-text text-danger" *ngIf="Ref11.errors.required">
                                                        Campo Obrigatório!
                                                    </small>
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-12 mt-50 ">
                                            <button routerLink="/plano/" class="btn btn-secondary botao-cancelar"
                                                rippleEffect>Cancelar</button>
                                            <button (click)="submitForm(cadastroForm)" type="submit"
                                                class="btn btn-primary btn-next " rippleEffect>
                                                <span class="align-middle d-sm-inline-block d-none">Salvar</span>
                                                <span *ngIf="loading"
                                                    class="spinner-border spinner-border-sm align-middle ml-sm-25 ml-0"></span>
                                                <span *ngIf="!loading">
                                                    <i *ngIf="!loading" data-feather="arrow-right"
                                                        class="align-middle ml-sm-25 ml-0"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>